// src/components/filter.
import React, {
  useMemo,
  Button,
  useState,
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { deletePCARE, getPCARE } from "service/api";
import Swal from "sweetalert2";
import Preloader from "components/Preloader/Preloader";



function DatatableTables() {

  const [Patientcare, setPatientcare] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllpatientcare();
  }, []);

  const getAllpatientcare = async () => {
    try {
      let response = await getPCARE();
      setPatientcare(response.data);
      // console.log(response.data);
    } catch (error) {
      console.log("Error while fetching data:", error)
    } finally {
      setLoading(false);
    }
  }

  const deletePCAREDetails = async (id) => {

    Swal.fire({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete this Patient care?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deletePCARE(id);
          setPatientcare(Patientcare.filter(site => site._id !== id));


          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Patient care deleted successfully!',
          });
          getAllpatientcare();
        } catch (error) {
          console.error('Error deleting Patient care:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Failed to delete Patient care.',
          });
        }
      }
    });
  };


  const columns = useMemo(
    () => [
      {
        Header: 'Sr. No.',
        accessor: (_row, i) => i + 1,
        id: 'srno',
        Cell: ({ value }) => <span style={{ fontWeight: '600', color: '#888' }}>{value}</span>,
      },
      {
        Header: 'Visit No.',
        accessor: 'visit_no',
        Cell: ({ value }) => (
          <span style={{ fontWeight: '600', color: '#DC4C64' }}>{value || '—'}</span>
        ),
      },
      {
        Header: 'Patient Name',
        accessor: 'visit_id',
        Cell: ({ row }) => {
          const patient = row.original.visit_id?.patientid;
          const name = patient
            ? `${patient.title || ''} ${patient.firstname || ''} ${patient.lastname || ''}`.trim()
            : row.original.firstname
              ? `${row.original.title || ''} ${row.original.firstname || ''} ${row.original.lastname || ''}`.trim()
              : '—';
          return <span style={{ fontWeight: '500' }}>{name}</span>;
        },
      },
      {
        Header: 'Chief Complaint',
        accessor: 'chiefcompliant',
        Cell: ({ value }) => value || '—',
      },
      {
        Header: 'Age / Gender',
        accessor: 'age',
        Cell: ({ row }) => {
          const o = row.original;
          const age = o.age || o.Age || o.visit_id?.patientid?.age || '';
          const gender = o.gender || o.visit_id?.patientid?.gender || '';
          return age || gender ? `${age}${age && gender ? ' / ' : ''}${gender}` : '—';
        },
      },
      {
        Header: 'OD Rx',
        accessor: 'od_spere',
        Cell: ({ row }) => {
          const o = row.original;
          const sph = o.od_spere || o.Prescription_right_sphere;
          const cyl = o.od_cyl   || o.Prescription_right_cyl;
          const axis = o.od_axis || o.Prescription_right_axis;
          if (!sph && !cyl) return '—';
          return (
            <span style={{ fontSize: '11px', fontFamily: 'monospace' }}>
              {sph || '0'} / {cyl || '0'} × {axis || '0'}
            </span>
          );
        },
      },
      {
        Header: 'OS Rx',
        accessor: 'os_spere',
        Cell: ({ row }) => {
          const o = row.original;
          const sph = o.os_spere || o.Prescription_left_sphere;
          const cyl = o.os_cyl   || o.Prescription_left_cyl;
          const axis = o.os_axis || o.Prescription_left_axis;
          if (!sph && !cyl) return '—';
          return (
            <span style={{ fontSize: '11px', fontFamily: 'monospace' }}>
              {sph || '0'} / {cyl || '0'} × {axis || '0'}
            </span>
          );
        },
      },
      {
        Header: 'Lens Coating',
        accessor: 'lens_type_od',
        Cell: ({ row }) => {
          const value = row.original.lens_type_od || row.original.lens_type || row.original.type;
          if (!value) return '—';
          const colors = { uc: '#6c757d', hc: '#0d6efd', hmc_blue: '#0dcaf0', shmc_blue: '#6610f2' };
          const labels = { uc: 'UC', hc: 'HC', hmc_blue: 'HMC Blue', shmc_blue: 'SHMC Blue' };
          return (
            <span style={{ background: colors[value] || '#aaa', color: '#fff', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600' }}>
              {labels[value] || value}
            </span>
          );
        },
      },
      {
        Header: 'Lens Material',
        accessor: 'lens_material',
        Cell: ({ row }) => {
          const value = row.original.lens_material_od || row.original.lens_material || row.original.material;
          return value || '—';
        },
      },
      {
        Header: 'Actions',
        accessor: '_id',
        Cell: ({ row }) => (
          <div style={{ display: 'flex', gap: '6px' }}>
            <Link
              className="btn btn-warning btn-sm"
              to={`/FullviewPatientcare/${row.original._id}`}
            >
              <i className="mdi mdi-eye"></i>
            </Link>
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => deletePCAREDetails(row.original._id)}
            >
              <i className="mdi mdi-trash-can"></i>
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const data = [

  ];

  //meta title
  document.title = "Patientcare | List";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="page-title">Patientcare List</h4>
          <Link to="/Addpatientcare" className="btn btn-primary">ADD New Patientcare</Link>
        </div>
        {/* <Breadcrumbs title="Setting" breadcrumbItem="Patientcare List" /> */}
        {/* <Table columns={columns} data={data} /> */}
        <div>
          <TableContainer columns={columns} data={Patientcare} isGlobalFilter={true} isAddOptions={false} customPageSize={10}
            className="custom-header-css" />
          {loading && <Preloader />}
        </div>
      </div>
    </div>
  );
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default DatatableTables;